import type {AliasToken} from 'ant-design-vue/es/theme/interface/alias';

import settings from '@/config/settings';

import antTheme from '@/assets/ant/theme';

const normalizeTheme = (theme: Partial<AliasToken>): Required<AliasToken> => {
  const calcTheme = antTheme.defaultAlgorithm({
    ...antTheme.defaultSeed,
    ...theme,
  }) as AliasToken;

  calcTheme.colorLink = calcTheme.colorPrimaryText;
  calcTheme.colorLinkHover = calcTheme.colorPrimaryBorderHover;
  calcTheme.colorLinkActive = calcTheme.colorPrimaryTextActive;

  return {
    ...calcTheme,
    ...theme,
  };
};

export const themeAdmin = normalizeTheme(settings.SERVICES.FRONT.THEME);
